// Guarded localStorage helpers for JSON-serialised preferences. A disabled or
// full store (private mode, SSR) degrades to `undefined` on read and a no-op on
// write instead of throwing. Reads return the raw parsed value as `unknown` — the
// caller validates its shape (each pref has its own schema).

export function readJsonPref(key: string): unknown {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
}

export function writeJsonPref(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable or full — preferences are best-effort.
  }
}
